import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { PavedParkingLotAssetService } from '#/app/shared/services/api/paved-parking-lot-asset.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a paved parking lot asset exists and belongs to the tenant in the route.
 * Prevents route matching if the asset doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const pavedParkingLotAssetAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const assetService = inject(PavedParkingLotAssetService);
  const assetIdParam = _currentSnapshot?.paramMap.get('assetId') ?? '';

  return resolveResourceAccessGuardResult(assetIdParam, (assetIdSignal) =>
    assetService.pavedParkingLotAssetResource(assetIdSignal as Signal<string>),
  );
};
